import Plyr from 'plyr'

export default () => {
    // const tapEventName = (window.ontouchstart === null) ? 'touchstart' : 'click';

    const players = Array.from(document.querySelectorAll('.js-video-player'))
        .map((p) => new Plyr(p, {
            hideControls: false,
            clickToPlay: true
        }))

    if (players.length < 1) {
        return false
    }
}


